var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseFilterWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 22,
    viewBox: "0 0 11 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.175 22a1.572 1.572 0 01-1.226-.581L.358 11.99a1.57 1.57 0 010-1.996L8.216.568a1.574 1.574 0 012.42 2.01l-7.025 8.423 6.79 8.422A1.57 1.57 0 019.175 22z",
    fill: "#fff"
  })));
}
export default SvgCloseFilterWindow;